import { lightBlue } from '@synoptic/ui-kit/palette.ts';
import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const customStreamCard = style([
  {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: borderRadius.r12,
    border: `1px solid ${themeVars.color.border.quaternary}`,
    gap: space.s8,
    height: 'fit-content',
    marginTop: space.s8,
  },
  responsiveStyle({
    mobile: {
      padding: space.s8,
    },
    tablet: {
      padding: space.s16,
    },
  }),
]);

export const cardHeader = style([
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
    flexWrap: 'wrap',
  },
]);

export const cardTitle = style([typography.titleSm]);

export const cardBadge = style([
  typography.bodySm,
  {
    borderRadius: borderRadius.r4,
    padding: `${space.s2}px ${space.s4}px`,
    background: themeVars.color.surface.primary.active,
    color: lightBlue[900],
    width: 'fit-content',
  },
]);
